import { Link, usePage } from '@inertiajs/react'
import type { ReactNode } from 'react'
import { t } from '@/lib/i18n'
import { isCurrent, logoutPath, memberMenu } from '@/layouts/navigation'

/**
 * 会員エリアのレイアウト（SiteLayout の内側。サイドメニュー付き）。
 * サイドメニューは支払い登録済みの会員にだけ表示する（未登録の会員はカード登録画面しか使えないため。従来と同じ）。
 */
export function MemberLayout({ children }: { children: ReactNode }) {
  const { url, props } = usePage()
  if (!props.auth.user?.payment_registered) return <MemberContent>{children}</MemberContent>

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-md-3 d-md-block side-menu">
          <div className="bg-light border-end fix-to-heighr">
            <div className="sidebar-heading"></div>
            <div className="list-group list-group-flush">
              {memberMenu(props.region).map((item) => (
                <Link
                  key={item.href}
                  href={item.href}
                  className={`list-group-item list-group-item-action ${isCurrent(url, item.activeWhen) ? 'bg-selected' : ''} bg-light`}
                >
                  <i className={`${item.icon} side-icon`}></i> {item.label}
                </Link>
              ))}
              <a href={logoutPath()} className="list-group-item list-group-item-action bg-light">
                <i className="fas fa-sign-out-alt side-icon"></i> {t('layouts.application.logout')}
              </a>
            </div>
            <div className="sidebar-footer"></div>
          </div>
        </div>
        <div className="col">
          <MemberContent>{children}</MemberContent>
        </div>
      </div>
    </div>
  )
}

/** 会員画面の本文（サイドメニューの右側）の余白と幅 */
export function MemberContent({ children }: { children: ReactNode }) {
  return (
    <div className="top-padding">
      <div className="container">
        <div className="row">
          <div className="col-md-10 offset-md-1 margin-bottom-100">{children}</div>
        </div>
      </div>
    </div>
  )
}
